import Amplify from "aws-amplify";
import amplifyConfig from "./amplifyConfig";

export default function authenticatorSetup() {
  Amplify.configure(amplifyConfig);
}
